import React, { useState } from 'react';
import axios from '../../plugins/axios';
import getLeadCard from '../../api/leads/getLeadCard';
import { useParams } from 'react-router-dom';
import { phone } from '../../constants/mask';

// components
import Form from '../../components/Form/Form';
import Alert from '../../components/Alert/Alert';

// icons
import phoneIcon from '../../brand/generated/input/phone.svg';

const actions = [{ type: 'button', action: 'Ð¡Ð¾Ð·Ð´Ð°ÑÑ ÑÐ´ÐµÐ»ÐºÑ' }];
const formStyles = {
  leadInfo: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a a a' 'b b b b'` },
  other: { display: 'grid' },
  actions: { display: 'grid', gap: '20px', gridTemplateColumns: 'auto auto auto auto auto', marginBottom: '0' },
};

const LeadEdit = () => {
  const { id } = useParams();
  const [error, setError] = React.useState({});
  const [succes, setSucces] = React.useState({});
  const [leadInfo, setLeadInfo] = useState([
    { type: 'date', value: undefined, name: 'created_at', label: 'ÐÐ°ÑÐ°' },
    { type: 'input', value: undefined, name: 'fio', label: 'ÐÐ¼Ñ', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¸Ð¼Ñ' },
    { type: 'select', value: undefined, name: 'sourceId', label: 'ÐÑÑÐ¾ÑÐ½Ð¸Ðº', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
    {
      type: 'input',
      value: undefined,
      name: 'phone',
      label: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½',
      placeholder: '+7(___) ___-__-__',
      icon: phoneIcon,
      mask: phone,
    },
    { type: 'input', value: '', name: 'email', label: 'Email', placeholder: 'example@gmail.com' },
    {
      type: 'selectMarks',
      value: undefined,
      name: 'markId',
    },
    {
      type: 'selectModels',
      value: undefined,
      name: 'modelId',
      params: () => leadInfo[5].value,
    },
    {
      type: 'select',
      label: 'Ð¡ÑÐ°ÑÑÑ',
      value: undefined,
      name: 'statusId',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      options: [],
    },
  ]);

  const [leadId, setLeadId] = React.useState(null);

  const handleSubmit = () => {
    // let object = new Object();
    // leadInfo.map((item) => {
    //   if (item) {
    //     if (item.value.value) {
    //       object[item.name] = item.value.value;
    //     } else {
    //       object[item.name] = item.value;
    //     }
    //   }
    // });
    // axios.post('/api/crm/leads/editLead', { ...object, id: parseInt(id) }).then((res) => {});
    console.log(rerender);
  };

  const init = async () => {
    await axios
      .get('/api/crm/leads/getLeadStatuses')
      .then((res) => {
        leadInfo[7].options = res.data.map((item) => {
          return { value: item.id, label: item.title };
        });
      })
      .catch((error) => {});
    await axios
      .get('/api/crm/leads/getLeadSources')
      .then((res) => {
        leadInfo[2].options = res.data.map((item) => {
          return { value: item.id, label: item.title };
        });
      })
      .catch((error) => {});
    await getLead();
    setRerender(rerender + 1);
  };

  const [rerender, setRerender] = React.useState(0);

  React.useEffect(() => {
    init();
  }, []);

  const getLead = async () => {
    await getLeadCard({ id: id }).then((res) => {
      leadInfo[0].placeholder = new Date(res.data.createdAt);
      leadInfo[1].placeholder = res.data.client.fullName;
      leadInfo[2].placeholder = res.data.source.title;
      leadInfo[3].placeholder = res.data.client.phone;
      leadInfo[4].placeholder = res.data.client.email;
      leadInfo[5].placeholder = res.data.mark?.name;
      leadInfo[6].placeholder = res.data.model?.name;
      leadInfo[7].placeholder = res.data.status?.title;
    });
    setLeadInfo([...leadInfo]);
  };

  const [other, setOther] = useState([
    {
      type: 'input',
      value: undefined,
      name: 'comment',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ Ð»Ð¸Ð´Ðµ',
      placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ Ð¾ Ð»Ð¸Ð´Ðµ',
    },
  ]);

  const addLeadComment = () => {
    axios
      .post('/api/crm/leads/addLeadComment', { comment: other[0].value, leadId: leadId })
      .then((res) => {})
      .catch((error) => {});
  };

  return (
    <>
      {rerender > 0 && (
        <div>
          <Form
            inputs={leadInfo}
            handlerSetState={setLeadInfo}
            title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð»Ð¸Ð´Ðµ'}
            grid={formStyles.leadInfo}
            action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð»Ð¸Ð´Ðµ'}
            handleSubmit={handleSubmit}
            border
          />
          {leadId != null && (
            <Form
              inputs={other}
              title={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾'}
              grid={formStyles.other}
              handleSubmit={addLeadComment}
              action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
              border
            />
          )}
          <Form inputs={actions} title={'ÐÐµÐ¹ÑÑÐ²Ð¸Ñ'} grid={formStyles.actions} border />
          {error.message && <Alert message={error.message} onClick={setError} />}
          {succes.message && <Alert message={succes.message} onClick={setSucces} />}
        </div>
      )}
    </>
  );
};

export default LeadEdit;
